import {load} from "react-cookies";
import {DisplaySettingType} from "../../../utils/const";
import {notNull} from "../../../utils/utils";

export const isOwner = setting => notNull(setting) && setting.owner === parseInt(load('user_id'));
